import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { configureStore } from "./configureStore";
import App from "./app/App";

import "./styles/index.scss";
import { ApiProvider } from "./providers/ApiProvider";
import { AppStoreProvider } from "./providers/AppStoreProvider";

const { store } = configureStore();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // VideoJS not working in Strict mode
  // https://github.com/videojs/video.js/issues/7746

  <React.StrictMode>
    <AppStoreProvider value={store}>
      <ApiProvider>
        <BrowserRouter>
          <Routes>
            <Route path="" element={<Navigate to="/lesson/123/1677" />} />
            <Route path="/lesson/:courseId">
              <Route path="" element={<App />} />
              <Route path=":lessonId" element={<App />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ApiProvider>
    </AppStoreProvider>
  </React.StrictMode>,
);
